export class Snackbar {
    constructor(
        public status_class: string = '',
        public text: string = '',
        public autoClose: boolean = true,
        public time: number = 3000,
        public action_buttons: any[] = null,
        public active: boolean = false
    ) {}

    activate() {
        this.active = true;
    }

    deactivate() {
        this.active = false;
    }

    setStatusClass(status_class: string) {
        this.status_class = status_class;
    }

    setText(text: string) {
        this.text = text;
    }

    setAutoClose(val: boolean) {
        this.autoClose = val;
    }

    setTime(time: number) {
        this.time = time;
    }

    setActionButtons(obj: any) {
        this.action_buttons = obj;
    }

    /**
     *
     * @param message Message you want to show in snackbar. By default ''.
     * @param status 'success' | 'error' | 'warning' | 'info'. By default 'info'.
     * @param autoClose By default True. Closes automatically without any interaction at 'this.time'
     */
    show(
        message: string = '',
        status: string = 'info',
        autoClose: boolean = true,
        time: number = 3000
    ): void {
        this.setText(message);
        this.setStatusClass(status);
        this.setAutoClose(autoClose);
        this.setTime(time);
        this.activate();
    }
}
